import type { Coupon } from 'shared-types/Coupon'
import { CouponSource, OfferType } from 'shared-types/Coupon'
import { ButtonType } from '../CouponButton'
import { isExternal } from 'mobx/Coupons/utils'

export enum ActionType {
	AddToCart = 'addToCart',
	Apply = 'apply',
	View = 'view',
}

export const toButtonType = (actionType: ActionType, { save, applied, signIn }: { save: boolean; applied: boolean; signIn: boolean }): ButtonType => {
	if (applied && signIn) {
		console.warn('Coupon cannot be applied if it requires to sign in')
		return ButtonType.NONE
	}

	switch (actionType) {
		case ActionType.AddToCart:
			if (applied) {
				return ButtonType.REMOVE_FROM_CART
			}

			if (signIn) {
				return save ? ButtonType.SIGN_IN_SAVE_AND_ADD_TO_CART : ButtonType.SIGN_IN_AND_ADD_TO_CART
			}

			return save ? ButtonType.SAVE_AND_ADD_TO_CART : ButtonType.ADD_TO_CART
		case ActionType.Apply:
			if (applied) {
				return ButtonType.UNAPPLY
			}

			if (signIn) {
				return save ? ButtonType.SIGN_IN_SAVE_AND_APPLY : ButtonType.SIGN_IN_AND_APPLY
			}

			return save ? ButtonType.SAVE_AND_APPLY : ButtonType.APPLY
		case ActionType.View:
			return signIn ? ButtonType.SIGN_IN_AND_VIEW : ButtonType.VIEW

		default:
			console.warn('Invalid action type', actionType)
			return ButtonType.NONE
	}
}

export const getRulesOfCoupon = (
	coupon: Coupon,
	authenticated: boolean
): { actionType: ActionType; signIn: boolean; save: boolean; applied: boolean } => {
	const external = isExternal(coupon)
	const requireLogin = !!coupon.flags.requireLogin?.value
	const signIn = requireLogin && !authenticated
	const save = (authenticated || requireLogin) && coupon.source !== CouponSource.LINKED
	const applied = !!coupon.flags.applied?.value
	const actionType = external ? ActionType.View : coupon.offerType === OfferType.ITEM ? ActionType.AddToCart : ActionType.Apply

	return { actionType, signIn, save, applied }
}
